import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@Context/CognitoAuthProvider';
import Navbar from '@Common/navbar/Navbar';

const PrivateRoutes: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    const intendedPath = location.pathname + location.search;
    if (intendedPath !== '/') {
      localStorage.setItem('intendedPath', intendedPath);
    }
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex h-full flex-col overflow-y-auto md:h-screen">
      <Navbar />
      <Outlet />
    </div>
  );
};

export default PrivateRoutes;
